import * as React from "react";

function SvgPlay2({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M15.485 2.25a2.75 2.75 0 012.745 2.582l.005.168v.445a2.749 2.749 0 011.727 2.387l.005.168v.427a2.752 2.752 0 011.776 2.379l.007.194v8a2.755 2.755 0 01-2.592 2.745l-.168.005H5.01a2.755 2.755 0 01-2.755-2.582L2.25 19v-8a2.75 2.75 0 011.781-2.572L4.032 8a2.75 2.75 0 011.734-2.556V5a2.75 2.75 0 012.582-2.745l.168-.005h6.969zm3.505 7.5H5.01c-.653 0-1.19.492-1.254 1.122L3.75 11v8c0 .647.495 1.18 1.131 1.244l.129.006h13.98c.653 0 1.189-.493 1.253-1.122L20.25 19v-8c0-.647-.495-1.18-1.131-1.244l-.129-.006zm-9.219 3.826c0-.932.973-1.527 1.791-1.137l.106.056 2.62 1.55c.78.462.819 1.56.116 2.084l-.117.077-2.62 1.55a1.256 1.256 0 01-1.89-.961l-.006-.12v-3.099zm1.5.427v2.244l1.897-1.122-1.897-1.122zm5.946-7.253H6.782a1.25 1.25 0 00-1.244 1.122L5.532 8l-.001.25h12.935l.001-.25a1.25 1.25 0 00-1.122-1.244l-.128-.006zm-1.732-3H8.516a1.25 1.25 0 00-1.244 1.122L7.266 5v.25h9.469V5a1.25 1.25 0 00-1.122-1.244l-.128-.006z"
        />
      </g>
    </svg>
  );
}

export default SvgPlay2;
